import SwitchButton from '../switch-button-field/SwitchButton';

interface CustomInputSwitchInterface {
  readonly inputLabel?: string;
  readonly value?: boolean;
  readonly name: string;
  readonly onChangeValue: (name: string, value: boolean) => void;
  fontSize?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}

/**
 * Custom input select box component
 * @param param0
 * @returns
 */
function CustomInputSwitch({
  inputLabel,
  value,
  name,
  onChangeValue,
  fontSize,
  disabled,
}: CustomInputSwitchInterface) {
  return (
    <div className="custom-input-switch-button-wrap">
      {inputLabel && <p className="input-label">{inputLabel}</p>}
      <div className="switch-size">
        <SwitchButton
          checked={value}
          disabled={disabled}
          change={() => onChangeValue(name, !value)}
          fontSize={fontSize}
        />
      </div>
    </div>
  );
}

CustomInputSwitch.defaultProps = {
  inputLabel: '',
  value: false,
  fontSize: 'large',
  disabled: false,
};

export default CustomInputSwitch;
